// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3DBF9","header":"MergedInvoice_header__E-RXR"};